import { ComponentProps, useMemo } from 'react';

import { dateUtils } from '@pukka/common/utils';

import { BillingContent } from './BillingContent';

interface BillingCurrentPlanProps {
  readonly loading?: boolean;
  readonly currentPlanName?: string;
  readonly lastPaymentDate?: string;
}

function BillingCurrentPlan({ loading, currentPlanName, lastPaymentDate }: BillingCurrentPlanProps) {
  const content = useMemo(() => {
    return [
      {
        icon: 'schedule',
        label: 'Subscription plan',
        children: currentPlanName,
      },
      {
        icon: 'wallet',
        label: 'Last payment',
        children: lastPaymentDate ? dateUtils.formatDate(lastPaymentDate) : 'N/A',
      },
    ] satisfies ComponentProps<(typeof BillingContent)['Row']>[];
  }, [currentPlanName, lastPaymentDate]);

  return (
    <BillingContent title="Current Plan">
      <BillingContent.Rows loading={loading} rows={content} />
    </BillingContent>
  );
}

export { BillingCurrentPlan };
